import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, IconButton, InputBase, Paper, Stack, Typography } from "@mui/material";
import AnalogIcon from "../../../../../assets/images/custom/analog_icon.svg";
import DigitalIcon from "../../../../../assets/images/custom/digital_icon.svg";
import { AddButton } from "../../../common/addButton";
import { Virtuoso } from "react-virtuoso";
import { useSelector } from "react-redux";
import { channelNamesAndConfig } from "../../../../model/slice/channelSlice";
import { isAnalogChannel } from "../../../../constants/channel/config";
import { DASHBOARD_ITEM_TYPE } from "../../constants";
import DeleteIcon from "../../../trendPage/icon/deleteIcon";
import { Search } from "@mui/icons-material";
import localizationKeys from "../../../../i18n/localizationKeys";
import { useTranslation } from "react-i18next";

export const AddChannelItems = (props) => {
  const { t } = useTranslation();
  const { setSelectedDashboard, existingChannelValues } = props;
  const channelNameAndConfig = useSelector(channelNamesAndConfig);
  const [displayChannels, setDisplayChannels] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!channelNameAndConfig) return;
    
    setDisplayChannels(channelNameAndConfig.filter((ch) => ch.chNo.includes(searchText) || ch.chName.includes(searchText)));
  }, [searchText, channelNameAndConfig]);

  const checkExist = (channel) => existingChannelValues.includes(channel.chNo);
  const addChannelItem = (channel) => {
    setSelectedDashboard((current) => {
      const newItems = current.items.concat({
        id: channel.chNo,
        position: {
          i: channel.chNo,
          x: 0,
          y: Infinity, // puts it at the bottom
          w: 4,
          h: 3,
        },
        type: "value",
        chNos: [channel.chNo],
      });
      return { ...current, items: newItems };
    });
  };

  const removeChannelItem = (channelNo, setSelectedDashboard) => {
    setSelectedDashboard((currentDashboard) => {
      const newItems = currentDashboard.items.filter((item) => {
        if (item.type === DASHBOARD_ITEM_TYPE.VALUE) {
          if (item.id !== channelNo) return true;
          return false;
        }
        return true;
      });
      return { ...currentDashboard, items: newItems };
    });
  };

  return (
    <Stack spacing={1} sx={{ height: "calc(100dvh - 150px)" }}>
      <Paper
        component="form"
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', background: "#36485a !important" }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1, color: "white" }}
          placeholder={t(localizationKeys.Search_lower)}
          inputProps={{ 'aria-label': 'search' }}
          onChange={ (evt) => setSearchText(evt.target.value) }
        />
        <IconButton type="button" sx={{ p: '10px', color: "white" }} aria-label="search">
          <Search color="white" />
        </IconButton>
      </Paper>
      <Virtuoso
        style={{ height: "100%" }}
        data={displayChannels}
        itemContent={(_, channel) => {
          const isExist = checkExist(channel);
          return (
            <Box
              key={channel.chNo}
              onClick={() => {
                if (isExist) {
                  removeChannelItem(channel.chNo, setSelectedDashboard);
                } else {
                  addChannelItem(channel);
                }
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "12px",
                border: isAnalogChannel(channel.chType)
                  ? "1px solid rgba(250, 48, 248, 0.7)"
                  : "1px solid rgba(132, 235, 128, 0.7)",
                padding: "1.5px 0 0.5px 6px",
                marginBottom: "8px",
                height: "35px",
                width: "100%",
                cursor: "pointer",
                color: "white",
                opacity: isExist ? 0.4 : 1,
              }}
            >
              <div style={{ display: "flex" }}>
                <img
                  src={isAnalogChannel(channel.chType) ? AnalogIcon : DigitalIcon}
                  style={{ height: "24px", width: "24px" }}
                />
                <Typography variant="body2">{channel.chName}</Typography>
              </div>
              <div>
                {isExist ? (
                  <IconButton sx={{ color: "white" }}>
                    <DeleteIcon />
                  </IconButton>
                ) : (
                  <AddButton onClickHandler={() => {}} disabled={false} />
                )}
              </div>
            </Box>
          );
        }}
      />
    </Stack>
  );
};

AddChannelItems.propTypes = {
  setSelectedDashboard: PropTypes.func,
  existingChannelValues: PropTypes.object,
};
